// +----------------------------------------------------------------------
// | 注册页
// +----------------------------------------------------------------------
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import '../../css/auth.less';

export default function Register() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { register } = useAuth();
  const navigate = useNavigate();

  const validate = () => {
    const name = username.trim();
    if (name.length < 3) return '用户名至少 3 个字符';
    if (password.length < 6) return '密码至少 6 位';
    if (password !== confirm) return '两次输入的密码不一致';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const msg = validate();
    if (msg) {
      setError(msg);
      return;
    }

    setError('');
    setLoading(true);
    try {
      await register({
        username: username.trim(),
        password,
        nickname: nickname.trim() || undefined,
      });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message || '注册失败，换一个用户名试试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-panel">
        <div className="auth-brand">
          <span className="auth-brand-name">想想</span>
          <span className="auth-brand-sub">从第一次纠结开始，就帮得上忙。</span>
        </div>

        <form className="auth-card" onSubmit={handleSubmit}>
          <h2 className="title-lg">注册</h2>
          <p className="muted" style={{ margin: '6px 0 20px' }}>
            不用填一堆资料，两步就好。
          </p>

          {error && <div className="auth-error">{error}</div>}

          <div className="field">
            <label htmlFor="username">用户名</label>
            <input
              id="username"
              className="input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="3~20 位，字母数字都行"
            />
          </div>

          <div className="field">
            <label htmlFor="nickname">昵称（可不填）</label>
            <input
              id="nickname"
              className="input"
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="想让我怎么称呼你"
            />
          </div>

          <div className="field">
            <label htmlFor="password">密码</label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 6 位"
            />
          </div>

          <div className="field">
            <label htmlFor="confirm">确认密码</label>
            <input
              id="confirm"
              className="input"
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="再输一次"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={loading}>
            {loading ? '注册中…' : '注册并开始'}
          </button>

          <div className="auth-switch">
            已经有账号？<Link to="/login">直接登录</Link>
          </div>
        </form>

        <Link to="/" className="auth-back">
          ← 先随便看看
        </Link>
      </div>
    </div>
  );
}
